const doc = [({"ja":({"adminLabelHotelCalendar":({"hotelSpecifiedStaysOnlyPeriods":"泊数限定期間", "period":"期間", "startDate":"開始日", "endDate":"終了日", "stays":"泊数"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;